import { render } from "./FormWrapper.vue?vue&type=template&id=2c37173d&scoped=true&ts=true"
import script from "./FormWrapper.vue?vue&type=script&lang=ts"
export * from "./FormWrapper.vue?vue&type=script&lang=ts"

import "./FormWrapper.vue?vue&type=style&index=0&id=2c37173d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c37173d"]])

export default __exports__